"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProducts = void 0;
var _fetching = require("@ori/fetching");
const subscriptionBenefitBanner = (0, _fetching.gql)`
  fragment SubscriptionBenefitBanner on Product {
    subscriptionBenefitBanner {
      title
      message
      registerLink {
        title
        relativeUrl
      }
      readMoreLink {
        title
        relativeUrl
      }
      signInLink {
        title
        relativeUrl
      }
    }
  }
`;
const shade = (0, _fetching.gql)`
  ${subscriptionBenefitBanner}
  fragment Shade on Product {
    ...SubscriptionBenefitBanner
    availability {
      isBackorder
    }
    shadeName
    hexColors
    colorImageUrl
    formattedPrice {
      bp
      price {
        basicCashback
        basicCataloguePrice
        combinedCashback
        currentPrice
        previousMinOfferPrice
        priceAfterImmediateDiscount
      }
    }
    isDiscontinued
    imageUrl
    labels {
      helpText
      labelKey
      productLabelDomain
      title
    }
    productExpectedInbound {
      expectedInboundLabel
    }
    pdpUrl {
      relativeUrl
    }
    productCode
    volumeValue
    volumeUnitText
    subscription {
      available
      frequency
      allowedFrequencies
    }
  }
`;
const concept = (0, _fetching.gql)`
  fragment Concept on Concept {
    brand {
      name
      url
    }
    name
    products {
      ...Shade
    }
    ratingAverage
    ratingCount
  }
`;
const product = (0, _fetching.gql)`
  ${concept}
  ${shade}
  fragment Product on Product {
    productCode
    concept {
      ...Concept
    }
  }
`;
const getProducts = exports.getProducts = (0, _fetching.gql)`
  query GetProducts($productCodes: [ID]) {
    products(productCodes: $productCodes) {
      ...Product
    }
  }
  ${product}
`;